import React, { useState } from 'react';
import './DocumentsHome.css';

// Document Icon
const DocumentIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

// Download Icon
const DownloadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

// View Icon
const ViewIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const DocumentsHome = () => {
  const [activeTab, setActiveTab] = useState('payslips');

  const tabs = [
    { id: 'payslips', label: 'Payslips' },
    { id: 'compensation', label: 'Compensation' },
    { id: 'experience', label: 'Experience Letter' },
    { id: 'relieving', label: 'Relieving Letter' },
    { id: 'hike', label: 'Hike Letter' },
  ];

  // Sample payslips data
  const payslipsData = [
    { id: 1, month: 'December 2025', date: '31-Dec-2025', status: 'Available' },
    { id: 2, month: 'November 2025', date: '30-Nov-2025', status: 'Available' },
    { id: 3, month: 'October 2025', date: '31-Oct-2025', status: 'Available' },
    { id: 4, month: 'September 2025', date: '30-Sep-2025', status: 'Available' },
    { id: 5, month: 'August 2025', date: '31-Aug-2025', status: 'Available' },
    { id: 6, month: 'July 2025', date: '31-Jul-2025', status: 'Available' },
  ];

  // Sample experience letters data
  const experienceData = [
    { id: 1, type: 'Experience Certificate', date: '01-Jan-2026', status: 'Pending Request' },
  ];

  // Sample relieving letters data
  const relievingData = [
    { id: 1, type: 'Relieving Letter', date: '--', status: 'Not Applicable' },
  ];

  // Sample hike letters data
  const hikeData = [
    { id: 1, type: 'Hike Letter - 2025', date: '01-Apr-2025', status: 'Available' },
    { id: 2, type: 'Hike Letter - 2024', date: '01-Apr-2024', status: 'Available' },
  ];

  // Sample compensation data
  const compensationData = [
    { id: 1, type: 'CTC Breakup - 2025', date: '01-Apr-2025', status: 'Available' },
    { id: 2, type: 'CTC Breakup - 2024', date: '01-Apr-2024', status: 'Available' },
    { id: 3, type: 'Offer Letter', date: '15-Jan-2024', status: 'Available' },
  ];

  const getTabData = () => {
    switch (activeTab) {
      case 'payslips':
        return payslipsData;
      case 'compensation':
        return compensationData;
      case 'experience':
        return experienceData;
      case 'relieving':
        return relievingData;
      case 'hike':
        return hikeData;
      default:
        return [];
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'Available':
        return 'status-available';
      case 'Pending Request':
        return 'status-pending';
      case 'Not Applicable':
        return 'status-na';
      default:
        return '';
    }
  };

  const renderContent = () => {
    const data = getTabData();

    if (activeTab === 'payslips') {
      return (
        <div className="documents-list">
          <div className="documents-table">
            <div className="table-header">
              <div className="table-cell">Month</div>
              <div className="table-cell">Generated Date</div>
              <div className="table-cell">Status</div>
              <div className="table-cell">Actions</div>
            </div>
            {data.map((item) => (
              <div className="table-row" key={item.id}>
                <div className="table-cell">
                  <span className="month-name">{item.month}</span>
                </div>
                <div className="table-cell">{item.date}</div>
                <div className="table-cell">
                  <span className={`status-badge ${getStatusClass(item.status)}`}>
                    {item.status}
                  </span>
                </div>
                <div className="table-cell actions-cell">
                  <button className="action-btn view-btn" title="View">
                    <ViewIcon />
                  </button>
                  <button className="action-btn download-btn" title="Download">
                    <DownloadIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    // For other tabs - show cards
    return (
      <div className="documents-cards">
        {data.length === 0 ? (
          <div className="empty-state">
            <DocumentIcon />
            <p>No documents available</p>
          </div>
        ) : (
          data.map((item) => (
            <div className="document-card" key={item.id}>
              <div className="card-icon">
                <DocumentIcon />
              </div>
              <div className="card-info">
                <h3>{item.type}</h3>
                <p className="card-date">Date: {item.date}</p>
                <span className={`status-badge ${getStatusClass(item.status)}`}>
                  {item.status}
                </span>
              </div>
              <div className="card-actions">
                {item.status === 'Available' && (
                  <>
                    <button className="action-btn view-btn" title="View">
                      <ViewIcon />
                    </button>
                    <button className="action-btn download-btn" title="Download">
                      <DownloadIcon />
                    </button>
                  </>
                )}
                {item.status === 'Pending Request' && (
                  <button className="request-btn">Request</button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  return (
    <div className="documents-home">
      {/* Tabs Navigation */}
      <div className="documents-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`documents-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="documents-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default DocumentsHome;

